import { Data } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';

export interface ISystemMaintenanceApiClient {

    /**
     * Creates accruals for investments that don't have any accrual records.
     */
    createAccruals(force: boolean): AxiosPromise<void>;

    /**
     * Checks if accruals of open ended investments need to be extended.
     */
    extendAccruals(): AxiosPromise;

    /** 
     * Returns the no of files that need to be transferred.
     */
    getTempFileCount(): AxiosPromise<number>;

    /** 
     * Loads temp files from the db, and transfers them to the appropriate blob container.
     */
    transferFiles(): AxiosPromise;

    // Client only properties / methods
}

@injectable()
export default class SystemMaintenanceApiClient extends Data.ApiClientBase implements ISystemMaintenanceApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/system-maintenance`);
    }

    public createAccruals(force: boolean): AxiosPromise<void> {
        return this.axios.post(`${this.apiPath}/create-accruals?force=${force}`);
    }

    public extendAccruals(): AxiosPromise {
        return this.axios.post(`${this.apiPath}/extend-accruals`);
    }

    public getTempFileCount(): AxiosPromise<number> {
        return this.axios.get(`${this.apiPath}/temp-file-count`);
    }

    public transferFiles(): AxiosPromise {
        return this.axios.post(`${this.apiPath}/transfer-temp-files`);
    }

    // Client only properties / methods
}